import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { AttachmentsPreview } from '@web/components/AttachmentsPreview/AttachmentsPreview';
import TaskIcon from '@web/assets/svg/Icons/32/task-gray.svg';
import ChecklistIcon from '@web/assets/svg/UI/checklist.svg';
import NotesIcon from '@web/assets/svg/UI/notes.svg';
import { NotificationModalRow } from '@web/components/NotificationModal/NotificationModalRow';
import AttachmentsIcon from '@web/assets/svg/Icons/32/attachment-gray.svg';
import { TaskInstance } from '@web/shiftTasks/types/TaskInstance';
import { TaskStatuses } from '@web/shiftTasks/types/TaskStatuses';
import { SubtasksInstance } from '@web/shiftTasks/ViewTaskInstance/ViewSubtasksInstance/Subtasks';

import { useShiftTaskInstanceModalInner } from './shiftTaskInstanceModalInner.hooks';

type Props = {
  shiftTask: TaskInstance;
};

export const ShiftTaskInstanceModalInner = ({ shiftTask }: Props) => {
  const { onCompleteSubtask } = useShiftTaskInstanceModalInner({ shiftTask });
  const attachmentsCount = shiftTask?.attachments.length;

  return (
    <>
      <NotificationModalRow
        icon={<TaskIcon aria-hidden={true} />}
        label={gettext('Title')}
        value={shiftTask.title}
      />

      <NotificationModalRow
        icon={<TaskIcon aria-hidden={true} />}
        label={gettext('Status')}
        value={shiftTask.status}
      />

      {shiftTask.description && (
        <NotificationModalRow
          icon={<NotesIcon aria-hidden={true} />}
          label={gettext('Description')}
          value={shiftTask.description}
        />
      )}

      {!!shiftTask.subtasks?.length && (
        <NotificationModalRow
          backgroundThemeColor={ThemeColorType.columnHeaders}
          icon={<ChecklistIcon aria-hidden={true} />}
          label={gettext('Subtasks')}
          value={
            <SubtasksInstance
              taskId={shiftTask.id}
              subtasks={shiftTask.subtasks}
              isDisabled={shiftTask.status === TaskStatuses.DONE}
              onCompleteSubtask={onCompleteSubtask}
            />
          }
        />
      )}

      {!!attachmentsCount && (
        <NotificationModalRow
          icon={<AttachmentsIcon aria-hidden={true} />}
          label={gettext('Attachments')}
          value={<AttachmentsPreview attachments={shiftTask.attachments} />}
        />
      )}
    </>
  );
};
